
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contest/create",
      function () {
        return require("private-next-pages/contest/create.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contest/create"])
      });
    }
  